// reducers.js
import { SET_RESPONSE_TEXT2} from './actions';

const initialState = {
  responseText2: '',
};

const responseReducer2 = (state = initialState, action) => {
  switch (action.type) {
    case SET_RESPONSE_TEXT2:
      return {
        ...state,
        responseText2: action.payload,
      };
    default:
      return state;
  }
};

export default responseReducer2;
